import { handleAdLink } from "@/utils/handleAdLink";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import { Alert } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { forwardRef, useMemo } from "react";
import { When } from "react-if";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

const AD_HEIGHT = 60;

const GlobalBanner = forwardRef(
  ({ onClose, visible, record, globalNotice, onCloseAds }, ref) => {
    const imageSrc = useMemo(() => {
      if (!record?.material?.data) return null;
      const url = `//${record.material.data.bucket_name}.huaban.com/${record.material.data.bucket_key}`;
      return gdImgSrcPolicy(url, {
        displayHeight: 60,
        aspectRatio: 60 / 1920,
        width: record.material?.width,
        height: record.material?.height,
        type: null,
      });
    }, [record]);

    const link = handleAdLink(record);

    const color = useMemo(() => {
      const link = record?.material.link || "";
      const search = link.split("?")[1] || "";
      return (
        search
          ?.split("&")
          ?.find((item) => item.startsWith("color="))
          ?.replace("color=", "") || "transparent"
      );
    }, [record]);

    if (!visible) {
      return null;
    }

    return (
      <>
        {globalNotice?.visible && globalNotice.content ? (
          <Alert
            className={styles.alert}
            closable={globalNotice.canClose}
            afterClose={onClose}
            style={{ height: AD_HEIGHT }}
            message={
              <>
                <span>{globalNotice.content}</span>
                <a
                  className={styles.link}
                  href={globalNotice.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {globalNotice.linkText}
                </a>
              </>
            }
          />
        ) : (
          <Link href={link.trim()}>
            <a
              ref={ref}
              className={classNames(styles.banner, ["modalOpenWidth"])}
              style={{ backgroundColor: color, height: AD_HEIGHT }}
              target={link.startsWith("http") ? "_blank" : "_self"}
              data-unique-id={record?.material.id}
              data-gd-click="resource_loc_click"
              data-gd-expose="resource_loc_expose"
              data-resource-type="图片"
              data-resource-id={record?.material.id}
              data-resource-title={record?.promotion.name}
              data-content-source={record?.position.alias}
              data-click-type="点击广告"
              rel="noreferrer nofollow"
            >
              <When condition={record}>
                <img {...imageSrc} alt={record?.material.tag} />
              </When>
              <div
                className={styles.close}
                onClick={(evt) => onCloseAds(evt, record)}
                data-gd-click="resource_loc_click"
                data-click-type="关闭广告"
              >
                <HBIcon type="ic_clear2" />
              </div>
              <When condition={record?.material.tag}>
                <div className={styles.label}>{record?.material.tag}</div>
              </When>
              <When condition={record?.material.tracker}>
                <img
                  src={record?.material.tracker}
                  alt="埋点"
                  style={{ display: "none" }}
                />
              </When>
            </a>
          </Link>
        )}
      </>
    );
  }
);

GlobalBanner.displayName = "GlobalBanner";

export default GlobalBanner;
